// src/util/notify.js
import React from 'react';
import { enqueueSnackbar, closeSnackbar } from 'notistack';
import { CButton } from '@coreui/react-pro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

// Funciones básicas existentes
export const show = (type, message) => {
  enqueueSnackbar(message, {
    variant: type,
    autoHideDuration: 5000,
  });
};

export const showNotification = (type, message) => {
  enqueueSnackbar(message, {
    variant: type,
    autoHideDuration: 5000,
  });
};

export const showWithAction = (message, readCallback) => {
  enqueueSnackbar(message, {
    variant: 'info',
    autoHideDuration: 10000,
    anchorOrigin: {
      vertical: 'bottom', // Opciones: 'top', 'bottom'
      horizontal: 'right', // Opciones: 'left', 'center', 'right'
    },
    iconVariant: {
      info: <FontAwesomeIcon icon={faBell} style={{marginRight: '10px'}} />,
    },
    action: (snackbarId) => (
      <>
        <CButton
          color="warning"
          onClick={() => closeSnackbar(snackbarId)}
          style={{ marginRight: '0.5rem' }}
        >
          Dismiss
        </CButton>
        <CButton
          color="info"
          onClick={() => {
            readCallback();
            closeSnackbar(snackbarId);
          }}
          style={{ marginRight: '0.5rem' }}
        >
          Read
        </CButton>
      </>
    ),
  });
};

export const responseError = (error, fallbackMessage) => {
  let msg = 'Ha ocurrido un error inesperado';

  if (error?.response?.data?.message) {
    msg = error.response.data.message;
  } else if (typeof error?.response?.data === 'string') {
    msg = error.response.data;
  } else if (fallbackMessage) {
    msg = fallbackMessage;
  }

  if (process.env.NODE_ENV === 'development') {
    console.error(error);
  }

  notify.error(msg);
};

export const responseSuccess = (data, fallbackMessage) => {
  let msg = 'Realizado con éxito';

  if (data?.message) {
    msg = data.message;
  } else if (fallbackMessage) {
    msg = fallbackMessage;
  }

  notify.success(msg);
};

export const notify = {
  responseError,
  responseSuccess,
  warn: (message) => show('warning', message),
  success: (message) => show('success', message),
  error: (message) => show('error', message),
  notify: (message) => showNotification('info', message),
  notifyWithAction: showWithAction,
};

export default notify;
